const MARQUEE_SCROLL_SPEED = 80;

const initMarqueeModule = (section) => {
  const root = section.querySelector('.marquee-module');
  const track = section.querySelector('.marquee-module__track');
  const set = section.querySelector('.marquee-module__set');

  if (!root || !track || !set) return;

  const update = () => {
    const fixedDuration = parseFloat(track.dataset.marqueeDuration);

    const duration = fixedDuration > 0 ? fixedDuration : set.getBoundingClientRect().width / MARQUEE_SCROLL_SPEED;

    if (!duration) return;

    track.style.setProperty('--marquee-duration', `${duration}s`);
    root.classList.add('is-marquee-ready');
  };

  update();

  document.fonts?.ready.then(update).catch(() => {});

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(update).observe(set);
  }
};

document.querySelectorAll('[data-component="mod-marquee-module"]').forEach(initMarqueeModule);
